import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import FiscalSalesAnalyserComponent from './fiscal-sales-analyser.component';

let FiscalSalesAnalyserModule = angular
  .module('FiscalSalesAnalyser', [
    uiRouter
  ])
  .component('fiscalSalesAnalyser', FiscalSalesAnalyserComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('fiscalSalesAnalyser', {
      url: '/fiscal-sales-analyser',
      data: {
        authRequired: true,
        permsRequired: ['sales-analyser']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'fiscalSalesAnalyser'
        }
      }
    });
  })
  .name;

export default FiscalSalesAnalyserModule;



// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-analyser/fiscal-sales-analyser.module.js